export default __webpack_public_path__ + "static/media/questionType.eaaac507.png";